// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.block-banner[data-v-2e8b8ee4]{margin-bottom:.1rem}@media (min-width:1024px){.block-banner[data-v-2e8b8ee4]{padding-right:.2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
